export const SINGLE_LINE_HEIGHT = 20
export const SPACE_ADJUSTMENT = 12
export const SPACE_ADJUSTMENT_FOR_SINGLE_LINE = SINGLE_LINE_HEIGHT + SPACE_ADJUSTMENT
export const CUT_OFF_HEIGHT = 110
